module.exports = __webpack_public_path__ + "img/202308_07.a653f10d.jpg";